import Handsontable from 'handsontable';
import $ from 'jquery';
import moment from 'moment';
import numbro from 'numbro';
import * as Models from '../Components/VehicleSchedule/VehicleScheduleModels';

export default class HandsontableUtility {
    exposureAction = {
        None: 0,
        Added: 1,
        Updated: 2,
        Removed: 3,
    };

    statuses = {
        newCart: 'New - Cart',
        editedCart: 'Edited - Cart',
    };

    getLicense() {
        return 'non-commercial-and-evaluation';
    }

    findAndRemove(array: any, property: any, value: any) {
        for (let i = array.length - 1; i >= 0; i--) {
            if (array[i][property] === value) {
                array.splice(i, 1);
            }
        }
    }

    requiredValidator(value: any, callback: any) {
        callback(value !== '' && value !== null);
    }

    lastFourValidator(value: any, callback: any) {
        if (typeof value === 'string') {
            callback(value.length <= 4);
        } else {
            callback(true);
        }
    }

    andValidators(f: any, g: any) {
        let result1: boolean = false;
        let result2: boolean = false;

        const cb1 = (val: any) => (result1 = val);
        const cb2 = (val: any) => (result2 = val);

        return (value: any, callback: any) => {
            f(value, cb1);
            g(value, cb2);
            callback(result1 && result2);
        };
    }

    descriptionLength125Validator(value: any, callback: any) {
        callback(!value || value.length <= 125);
    }

    autoCompleteRequiredValidator(value: any, callback: any) {
        const that: any = this;
        let valueToValidate = value;

        //copying this function from the handsontable js file
        //v is value and c is callback but i'm making this an inline function
        // to not expose it to anything else
        const process = (v: any, c: any) => {
            const originalVal = v;
            return (source: any) => {
                let found = false;

                for (let s = 0, slen = source.length; s < slen; s++) {
                    if (originalVal === source[s]) {
                        found = true; // perfect match
                        break;
                    }
                }

                c(found);
            };
        };

        if (valueToValidate === null || valueToValidate === void 0) {
            valueToValidate = '';
        }

        if (that.allowEmpty && valueToValidate === '') {
            callback(true);
            return;
        }

        if (!that.allowEmpty && valueToValidate === '') {
            callback(false);
            return;
        }

        if (that.strict && that.source) {
            if (typeof that.source === 'function') {
                that.source(valueToValidate, process(valueToValidate, callback));
            } else {
                process(valueToValidate, callback)(that.source);
            }
        } else {
            callback(true);
        }
    }

    createDropdownArray(list: any, key: any, includeEmptyRow: boolean = false) {
        const items: any[] = [];

        if (includeEmptyRow) {
            items.push('');
        }

        list.forEach((item: any) => {
            items.push(item[key]);
        });
        return items;
    }

    canRemoveRow(requestType: string) {
        return $(requestType).val() !== 'Policy';
    }

    static updateValue(value: any, id: any, rowData: any) {
        rowData[id] = value;
    }

    static cellChanged(updatedData: any, cellName: string) {
        return updatedData[1] === cellName;
    }

    updateDropdownValue(rowData: any, updatedData: any, columnName: string, columnId: any, lookupValues: any) {
        if (HandsontableUtility.cellChanged(updatedData, columnName)) {
            const selectedValue = updatedData[3] !== null ? updatedData[3].trim() : null;

            const lookupValue = !!selectedValue ? lookupValues[selectedValue] : null;
            HandsontableUtility.updateValue(lookupValue, columnId, rowData);
        }
    }

    updateRowChange(grid: any, rowData: any, rowDataProperty: any, requestType: any) {
        let expAction = this.exposureAction.Updated;

        if (!rowData[rowDataProperty]) {
            expAction = this.exposureAction.Added;
        }

        this.setRowChangeEvent(rowData, expAction);
        return this.setPolicyStatusChangeEvent(grid, rowData, requestType);
    }

    setRowChangeEvent(rowData: any, action: any) {
        if (rowData.exposureAction !== this.exposureAction.Added) {
            rowData.exposureAction = action;
        }
    }

    setPolicyStatusChangeEvent(grid: any, rowData: any, requestType: any) {
        if (requestType === 'Policy') {
            // need to look at both since I messed up the building grid by using DTOs
            if (
                (!rowData.status && !rowData.activeStatus) ||
                (rowData.status && rowData.status.toLowerCase().indexOf('new') === -1) ||
                (rowData.activeStatus && rowData.activeStatus.toLowerCase().indexOf('new') === -1)
            ) {
                if (rowData.status !== 'Modified' && rowData.activeStatus !== 'Modified') {
                    rowData.status = rowData.activeStatus = 'Modified';
                    return true;
                }
            }
        }
    }

    beforePaste(data: any, coords: any) {
        data.forEach((item: any) => {
            for (const prop in item) {
                if (item[prop]) {
                    item[prop] = item[prop].trim();
                }
            }
        });
    }

    addSearch(searchFieldId: any, grid: any) {
        const searchField = document.getElementById(searchFieldId);

        Handsontable.dom.addEvent(searchField, 'keyup', function () {
            const search = grid.getPlugin('search');
            search.query(this.value);
            grid.render();
        });
    }

    isChangeSourceToIgnore(source: any) {
        if (
            source === 'loadData' ||
            source === 'UndoRedo.undo' ||
            source === 'UndoRedo.redo' ||
            source === 'dateValidator' ||
            source === 'revalidating' ||
            source === 'ObserveChanges.change'
        ) {
            // should we disable undo / redo?
            return true;
        }

        return false;
    }

    getDefaultDateRenderer(defaultValues: any) {
        return function (instance: any, td: any, row: any, col: any, prop: any, value: any, cellProperties: any) {
            const args = arguments;

            if (args[5] === null && instance.isEmptyRow(row) && defaultValues[prop]) {
                args[5] = defaultValues[prop];
                td.style.color = '#999';
            } else {
                td.style.color = '';
            }
            (Handsontable.renderers as any).DateRenderer.apply(this, args);
        };
    }

    getDefaultCheckBoxRenderer(defaultValues: any) {
        return function (instance: any, td: any, row: any, col: any, prop: any, value: any, cellProperties: any) {
            const args = arguments;

            if (args[5] === null && instance.isEmptyRow(row) && defaultValues[prop]) {
                args[5] = defaultValues[prop];
                td.style.color = '#999';
            } else {
                td.style.color = '';
            }
            (Handsontable.renderers as any).CheckboxRenderer.apply(this, args);
        };
    }

    getDefaultNumericRenderer(defaultValues: any) {
        return function (instance: any, td: any, row: any, col: any, prop: any, value: any, cellProperties: any) {
            const args = arguments;
            if (args[5] === null && instance.isEmptyRow(row) && defaultValues[prop]) {
                args[5] = defaultValues[prop];
                td.style.color = '#999';
            } else {
                td.style.color = '';
            }
            (Handsontable.renderers as any).NumericRenderer.apply(this, args);
        };
    }

    getDefaultDropdownRenderer(defaultValues: any) {
        return function (instance: any, td: any, row: any, col: any, prop: any, value: any, cellProperties: any) {
            const args = arguments;

            if (args[5] === null && instance.isEmptyRow(row) && defaultValues[prop]) {
                args[5] = defaultValues[prop];
                td.style.color = '#999';
            } else {
                td.style.color = '';
            }

            Handsontable.renderers.AutocompleteRenderer.apply(this, args);
        };
    }

    getBeforeChangeFunction(grid: any, defaultValues: any, stateVariables?: any) {
        const self = this;
        return function (changes: any, source: any) {
            let instance = grid;

            if (!instance) {
                instance = this.getInstance();
            }

            const ilen = changes.length;
            const clen = instance.countCols();
            const rowColumnSeen: any = {};
            const rowsToFill: any = {};
            const additionalChangesToAdd: any[] = [];
            const compDeductibleChange: any[] = [];
            const collDeductibleChange: any[] = [];
            const isComprehensiveSelectedChange: any[] = [];

            let i: number;
            let c: number;

            for (i = 0; i < ilen; i++) {
                // if oldVal is empty
                if (!changes[i][2] && changes[i][3]) {
                    if (instance.isEmptyRow(changes[i][0])) {
                        // add this row/col combination to cache so it will not be overwritten by template
                        rowColumnSeen[changes[i][0] + '/' + changes[i][1]] = true;
                        rowsToFill[changes[i][0]] = true;
                    }
                }

                const adjustmentTypeToAdd = self.setAdjustmentPercentIfNotNextChange(instance, changes[i], changes[i + 1]);
                if (adjustmentTypeToAdd && adjustmentTypeToAdd.length) {
                    additionalChangesToAdd.push(adjustmentTypeToAdd);
                }

                if (stateVariables) {
                    if (changes[i][1] === 'comprehensiveDeductible' || changes[i][1] === 'collisionDeductible') {
                        const newDeductible = changes[i][3];

                        const deductibleList = changes[i][1] === 'comprehensiveDeductible' ? stateVariables.apdComprehensiveDeductibles : stateVariables.apdCollisionDeductibles;

                        const newDeductibleObj = deductibleList.filter((element: Models.IDeductibleDetails, index: any, array: any) => {
                            return element.deductible === newDeductible;
                        });

                        if (changes[i][1] === 'comprehensiveDeductible') {
                            if (newDeductibleObj[0]) {
                                const dedFactor: any[] = [changes[i][0], 'comprehensiveDeductibleFactor', null, newDeductibleObj[0].deductibleFactor];
                                compDeductibleChange.push(dedFactor);
                            }
                        } else if (changes[i][1] === 'collisionDeductible') {
                            if (newDeductibleObj[0]) {
                                const dedFactor: any[] = [changes[i][0], 'collisionDeductibleFactor', null, newDeductibleObj[0].deductibleFactor];
                                collDeductibleChange.push(dedFactor);
                            }
                        }
                    } else if (changes[i][1] === 'isCollisionElected') {
                        const checkedValue: boolean = changes[i][3];

                        if (checkedValue) {
                            const isCompSel: any[] = [changes[i][0], 'isComprehensiveElected', null, true];

                            isComprehensiveSelectedChange.push(isCompSel);
                        }
                    } else if (changes[i][1] === 'isComprehensiveElected') {
                        const checkedValue: boolean = changes[i][3];

                        if (!checkedValue) {
                            const checkEdit: any[] = [changes[i][0], 'isCollisionElected', null, false];

                            isComprehensiveSelectedChange.push(checkEdit);
                        }
                    }
                }
            }

            for (const r in rowsToFill) {
                if (rowsToFill.hasOwnProperty(r)) {
                    for (c = 0; c < clen; c++) {
                        const propName = instance.colToProp(c);
                        // if it is not provided by user in this change set, take value from template
                        if (!rowColumnSeen[r + '/' + propName] && defaultValues[propName]) {
                            changes.push([r, propName, null, defaultValues[propName]]);
                        }
                    }
                }
            }

            for (i = 0; i < additionalChangesToAdd.length; i++) {
                changes.push(additionalChangesToAdd[i]);
            }

            if (stateVariables) {
                for (i = 0; i < compDeductibleChange.length; i++) {
                    changes.push(compDeductibleChange[i]);
                }

                for (i = 0; i < collDeductibleChange.length; i++) {
                    changes.push(collDeductibleChange[i]);
                }

                for (i = 0; i < isComprehensiveSelectedChange.length; i++) {
                    changes.push(isComprehensiveSelectedChange[i]);
                }
            }
        };
    }

    setAdjustmentPercentIfNotNextChange(instance: any, currentChange: any, nextChange: any) {
        const row = currentChange[0];
        const column = currentChange[1];
        const newValue = currentChange[3];

        if (column === 'amount' && newValue) {
            const percentColIndex = instance.propToCol('isPercentDisplay');
            const isPercent = instance.getDataAtCell(row, percentColIndex);
            if (!isPercent && !(nextChange && nextChange[1] === 'isPercentDisplay')) {
                return [row, 'isPercentDisplay', null, '$'];
            }
        }
    }

    revalidatePropertyOnChange(onChangeProperty: any, otherProperty: any, changes: any, source: any, hotCore: any) {
        const onChangePropertyChanges = this.getChangesForProperty(changes, onChangeProperty);
        if (source !== 'revalidating') {
            const newValues: any = [];
            for (const i in onChangePropertyChanges) {
                const rowId = onChangePropertyChanges[i][0];
                const columnId = hotCore.propToCol(otherProperty);
                const currentValue = hotCore.getDataAtCell(rowId, columnId);
                newValues.push([rowId, columnId, currentValue]);
            }

            if (newValues.length > 0) {
                hotCore.setDataAtCell(newValues, null, null, 'revalidating');
            }
        }
    }

    getChangesForProperty(changes: any, property: any): any[] {
        const propertyChanges = [];
        for (const i in changes) {
            const changedProperty = changes[i][1];

            if (changedProperty === property) {
                propertyChanges.push(changes[i]);
            }
        }
        return propertyChanges;
    }

    fixCheckboxValue(changes: any, property: any, source: any, hotCore: any) {
        changes = this.getChangesForProperty(changes, property);
        const newValues: any = [];

        for (const i in changes) {
            let value = changes[i][3];
            if (source !== 'fixingCheckbox') {
                const rowId = changes[i][0];
                const columnId = hotCore.propToCol(property);

                if (value === 'true') {
                    value = true;
                } else if (value === 'false') {
                    value = false;
                } else if (!!value === false) {
                    value = false;
                }

                newValues.push([rowId, columnId, value]);
            }
        }

        if (newValues.length > 0) {
            hotCore.setDataAtCell(newValues, null, null, 'fixingCheckbox');
        }
    }

    // Fix values in currency formatted cells.  If you copy and paste a currency string
    // with formatting (e.g. $1,234.56), we need to convert this to a number data type.
    // This will also take any input that cannot be formatted as a number and set
    // the cell value to null instead.
    fixCurrencyValue(changes: any, property: any, source: any, hotCore: any) {
        changes = this.getChangesForProperty(changes, property);
        const newValues: any = [];

        for (const i in changes) {
            let value = changes[i][3];
            if (source !== 'fixingCurrency') {
                const rowId = changes[i][0];
                const columnId = hotCore.propToCol(property);

                if (typeof value === 'string') {
                    value = parseFloat(value.replace('$', '').replace(/,/g, ''));

                    if (isNaN(value)) {
                        value = null;
                    }

                    newValues.push([rowId, columnId, value]);
                }
            }
        }

        if (newValues.length > 0) {
            hotCore.setDataAtCell(newValues, null, null, 'fixingCurrency');
        }
    }

    createGuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    afterChangeWrapper(afterChangeDelegate: any, additionalChangeLogic: any, propId: any, requestType: any) {
        const self = this;
        return function (changes: any, source: any) {
            if (!changes || self.isChangeSourceToIgnore(source)) {
                return;
            }
            const grid = this.getInstance();

            let rerender: boolean = false;

            $.each(changes, (key, value) => {
                const physicalRowIndex = grid.toPhysicalRow(value[0]);
                const rowData = afterChangeDelegate(value, physicalRowIndex);

                const result = self.updateRowChange(grid, rowData, propId, requestType);
                if (!rerender && result) {
                    rerender = true;
                }
            });

            if (additionalChangeLogic) {
                additionalChangeLogic(changes, source);
            }

            if (rerender) {
                grid.render();
            }
        };
    }

    removeRowWrapper(handler: any) {
        return (visualIndex: number, amount: number, physicalRows: any) => {
            let cancelOperation: boolean = false;

            physicalRows.forEach((row: any) => {
                const result: boolean = handler(row);
                if (result !== undefined && !result && !cancelOperation) {
                    cancelOperation = true;
                }
            });

            return !cancelOperation;
        };
    }

    emptyRowHandler(dataset: any, grid: any) {
        const cleanedLocationGridData: any[] = [];

        $.each(dataset, (rowKey: any, object: any) => {
            if (!grid.isEmptyRow(rowKey)) {
                cleanedLocationGridData[rowKey] = object;
            }
        });

        return cleanedLocationGridData;
    }

    getScrubbedData(dataset: any, grid: any, removedRows: any) {
        const scrubbedData = this.emptyRowHandler(dataset, grid);
        return $.merge($.merge([], scrubbedData), removedRows);
    }

    // Custom Renderers
    statusRender(instance: any, td: Element, row: HTMLTableRowElement, col: number, prop: any, value: any, cellProperties: any) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);

        if (value) {
            if (value.toString().startsWith('New')) {
                td.className = 'new-cart-item';
            }

            if (value.toString().startsWith('Edit')) {
                td.className = 'edited-cart-item';
            }

            if (value.toString().startsWith('Modified')) {
                td.className = 'modified-row';
            }
        }
    }

    static adjustmentRenderer(hotInstance: any, td: HTMLTableElement, row: HTMLTableRowElement, column: number, prop: any, value: any, cellProperties: any) {
        Handsontable.renderers.BaseRenderer.apply(this, arguments);

        if (!value) {
            td.innerHTML = '';
            return;
        }

        // handsontable (v3.0) is using an old numbro js version so need to use the old format
        // 4.0 updates numbro so we may need to update this when we update the grid
        const typeValue = hotInstance.getDataAtCell(row, column + 1); // assume type col is adjacent

        value = HandsontableUtility.removeThousandSeparator(value);

        const displayValue = parseFloat(value);

        if (typeValue && typeValue === '%') {
            td.innerHTML = numbro(displayValue / 100).format('0.00%');
        } else {
            const isNumeric = !isNaN(value);

            if (isNumeric) {
                td.innerHTML = numbro(displayValue).format('$0,0');
            }

            if (!typeValue) {
                hotInstance.setDataAtCell(row, column + 1, '$');
            }
        }
    }

    static currencyRenderer(hotInstance: any, td: HTMLTableElement, row: HTMLTableRowElement, column: number, prop: any, value: any, cellProperties: any) {
        HandsontableUtility.numericRenderer(hotInstance, td, row, column, prop, value, cellProperties, true);
    }

    static numericRenderer(
        hotInstance: any,
        td: HTMLTableElement,
        row: HTMLTableRowElement,
        column: number,
        prop: any,
        value: any,
        cellProperties: any,
        isCurrency: boolean = false,
    ) {
        Handsontable.renderers.BaseRenderer.apply(this, arguments);
        numbro.setLanguage('en-US');

        if (!value && value !== 0) {
            td.innerHTML = '';
            return;
        }

        value = HandsontableUtility.removeThousandSeparator(value);

        const isNumeric = !isNaN(value);

        if (!isNumeric) {
            td.innerHTML = '';
            return;
        }

        const displayValue = parseFloat(value);
        const format = isCurrency ? '$0,0' : '0,0';

        if (isCurrency) {
            td.innerHTML = numbro(displayValue).formatCurrency(format);
        } else {
            td.innerHTML = numbro(displayValue).format({ thousandSeparated: true });
        }
    }

    static customNumericValidator = (enteredValue: any, callback: any) => {
        enteredValue = HandsontableUtility.removeThousandSeparator(enteredValue);
        const isNumeric = !isNaN(enteredValue) && !!enteredValue;
        callback(isNumeric);
    };

    static removeThousandSeparator = (value: any) => {
        if (typeof value === 'string') {
            return value.replace(',', '');
        }
        return value;
    };

    registerCustomRenderers() {
        (Handsontable.renderers as any).registerRenderer('statusRender', this.statusRender);
        (Handsontable.renderers as any).registerRenderer('adjustmentRenderer', HandsontableUtility.adjustmentRenderer);
        (Handsontable.renderers as any).registerRenderer('currencyRenderer', HandsontableUtility.currencyRenderer);
        (Handsontable.renderers as any).registerRenderer('numericRenderer', HandsontableUtility.numericRenderer);
        (Handsontable.validators as any).registerValidator('custom-numeric-validator', HandsontableUtility.customNumericValidator);
        //        (Handsontable.validators as any).registerValidator('description_length_125_validator', HandsontableUtility.descriptionLength125Validator);
    }

    isSorted(hotInstance: any) {
        return hotInstance.getPlugin('columnSorting').isSorted();
    }

    reApplySort(hotInstance: any) {
        if (this.isSorted(hotInstance)) {
            const sortConfig = hotInstance.getPlugin('columnSorting').getSortConfig()[0];
            hotInstance.getPlugin('columnSorting').sort({
                column: sortConfig.column,
                sortOrder: sortConfig.sortOrder,
            });
        }
    }

    // TONY do u need this?
    // http://jsfiddle.net/dFNva/1/
    // Description: Sort by object key, with optional reverse ordering, priming
    private by(field: string, reverse: any, primer: any) {
        const key = (x: any) => {
            return primer ? primer(x[field]) : x[field];
        };

        return (a: any, b: any) => {
            const A = key(a);
            const B = key(b);

            return (A < B ? -1 : A > B ? 1 : 0) * [-1, 1][+!!reverse];
        };
    }

    // common between schedules - do I put this here or on the common validator?
    validateCoverageDates = (enteredValue: string, rowData: any, prop: string, defaultEffectiveDate: Date, defaultExpirationDate: Date): boolean => {
        let isValid: boolean = true;
        const dateFormat: string = 'MM/DD/YYYY';

        if (prop === 'effectiveDate' && rowData.effectiveDate) {
            isValid = moment(enteredValue, dateFormat).isSameOrBefore(moment(rowData.expirationDate, dateFormat));
        } else if (prop === 'expirationDate' && rowData.expirationDate) {
            isValid = moment(enteredValue, dateFormat).isSameOrAfter(moment(rowData.effectiveDate, dateFormat));
        }

        if (prop === 'effectiveDate' || prop === 'expirationDate') {
            const beforeCoverage = moment(enteredValue, dateFormat).isSameOrAfter(moment(defaultEffectiveDate, dateFormat));

            const afterCoverage = moment(enteredValue, dateFormat).isSameOrBefore(moment(defaultExpirationDate, dateFormat));

            isValid = isValid && beforeCoverage && afterCoverage;
        }

        return isValid;
    };

    // common between schedules
    validateSharedPercentage = (enteredValue: number, rowData: any, prop: string): boolean => {
        let isValid: boolean = true;
        if (prop === 'sharedPercentage' && rowData.sharedPercentage) {
            if (enteredValue < 0 || enteredValue > 100) {
                isValid = false;
            }
        }
        return isValid;
    };
}
